import { CommonService } from './../../../services/utils/common.service';
import { CalendarTranslateService } from './../../../modules/UIKit/services/calendarTranslate.service';
import { Router } from '@angular/router';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { PromotionCatalogService } from './../../../services/promotion/promotion-catalog.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService, SelectItem } from 'primeng/api';
import * as moment from 'moment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.css']
})
export class CatalogComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  numberFilter = KontableComponent.NumberFilter;
  selectFilter = KontableComponent.SelectFilter;
  dateFilter = KontableComponent.DateFilter;
  filterDateStart: Date;
  filterDateEnd: Date;

  invalidSubmit: boolean = false;
  form: FormGroup;
  checkboxLabel: any;

  record = {};
  dialog: boolean = false;
  catalogImportGift: SelectItem[] = [];

  @ViewChild('table') table: any;

  constructor(
    public catalogService: PromotionCatalogService,
    private router: Router,
    public calendarTranslateService: CalendarTranslateService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private translate: TranslateService,
    private message: MessageService
  ) { }

  ngOnInit() {
    this.translate.get([
      'catalog.updateValue'
    ]).subscribe((res) => {
      this.checkboxLabel = res['catalog.updateValue'];
    });
  }

  editCatalog(id: number) {
    this.router.navigate([`promotion/catalog/detail/${id}`]);
  }

  addCatalog() {
    this.router.navigate(['promotion/catalog/detail']);
  }

  deleteCatalog(id: number, table) {
    this.catalogService.deleteCatalog(id).subscribe(() => table.refresh());
  }

  goToGiftList(catalog) {
    this.router.navigate([`promotion/catalog/${catalog.id}/gift`, {catalogName: catalog.description}]);
  }

  /**
   * Filtro data inizio
   */
  onChangeDateStart(field) {
    if (this.filterDateStart) {
      this.table.updateTableFilter(field, this.commonService.fromDateToDBString(this.filterDateStart), 'equals');
    } else {
      let index = this.table.filter.search.findIndex(f => f.key === field);
      if (index > -1) {
        this.table.filter.search.splice(index, 1);
        this.table.refresh();
      }
    }
  }

  /**
   * Filtro data fine
   */
  onChangeDateEnd(field) {
    if (this.filterDateEnd) {
      this.table.updateTableFilter(field, this.commonService.fromDateToDBString(this.filterDateEnd), 'equals');
    } else {
      let index = this.table.filter.search.findIndex(f => f.key === field);
      if (index > -1) {
        this.table.filter.search.splice(index, 1);
        this.table.refresh();
      }
    }
  }

  /**
   * Metodo per la visualizzazione del pop-up di Articoli
   */
  showDetail($event){
    this.record = $event;
    this.getCatalogImportGift();
    this.dialog = true;

    this.form = this.fb.group({
      catalog: $event.code + ' - ' + $event.description,
      head: [''],
      update: false
    })
  }

  /**
   * Metodo che chiude il pop-up di Articoli
   */
   closeDialog(){
    this.dialog = false;
  }


  getCatalogImportGift(){
    //Popolo il dropdown dei gift type
    this.catalogService.getCatalogImportGift().subscribe(el => {
      el.forEach(el => this.catalogImportGift.push({ value: el.id, label: el.description }))
    });
  }

  importArticle(){
    const Data = {
      update: this.form.get('update').value ? '1' : '0'
    };
    this.catalogService.importArtcle(this.record['id'], this.form.get('head').value, Data.update).subscribe( res =>{
      this.message.add({severity: 'info', summary: 'Import Info', detail: res})
      this.closeDialog();
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/catalog/catalog.component.ts